import { useContext } from "react";
import { PaymentFlowContext } from "../context/PaymentFlowContext";

const usePaymentFlow = () => {
    return useContext(PaymentFlowContext);
};

export default usePaymentFlow;
